import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

import { getBackendUrl } from '../utils/getBackendUrl';
const BACKEND_URL = getBackendUrl();
const API = `${BACKEND_URL}/api`;

export const useActivityTracking = (user) => {
  const location = useLocation();

  useEffect(() => {
    if (!user) return;

    const getPageName = (pathname) => {
      const routes = {
        '/dashboard': 'Dashboard',
        '/projects': 'Projects',
        '/chat': 'Chat',
        '/timeclock': 'Time Clock',
        '/profile': 'Profile',
        '/team': 'Team',
        '/reports': 'Reports',
        '/settings': 'Settings',
        '/services': 'Services'
      };

      // Check for dynamic routes
      if (pathname.startsWith('/projects/')) return 'Project Details';
      if (pathname.startsWith('/services/')) return 'Service Details';
      if (pathname.startsWith('/profile/')) return 'Profile';

      return routes[pathname] || 'Unknown Page';
    };

    const updateActivity = async () => {
      try {
        await axios.post(`${API}/users/activity`, {
          current_page: getPageName(location.pathname)
        });
      } catch (error) {
        console.error('Failed to update activity:', error);
      }
    };

    // Update immediately
    updateActivity();

    // Update every 30 seconds
    const interval = setInterval(updateActivity, 30000);

    return () => clearInterval(interval);
  }, [location, user]);
};
